export default "__VITE_ASSET__cae97fad__"